import { Button, InputNumber, Col, Form, Input,notification, Modal, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { storeLoadingSavingGsuBaseline, UpdateGsuHistoryBaseline, updateSumTotalForecast, updateTotalGSU } from '../../Redux/Reducers/Baseline'
import {
    LoadingOutlined
} from '@ant-design/icons'

const ModalUpdateGsuTon = (
{
    openModal=false,
    setOpenModal=()=>{},
    dataPeriodo,
    setDataPeriodo,
    rex_filter_data_baseline,
    rex_loading_saving_gsu
}) => {

	const { 
        rex_info_status_dashboard,
	} = useSelector(state => state.baseline)

    let [ savingGsu, setSavingGsu ] = useState(false)

    const [form] = Form.useForm();

    const [api, contextHolder] = notification.useNotification()

    const openAlertNotify = (description) => {
		api['warning']({
		  message: 'Alerta',
		  description: description
		})
	}

    const dispatch = useDispatch()

    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const onFinishForm = async (values) => {

        console.log(values)
        if(isNaN(values.gsuNew) || values.gsuNew == undefined){
            openAlertNotify('Entrada nó válida')
        }else{
            dispatch(storeLoadingSavingGsuBaseline(true))
            dispatch(updateTotalGSU({ value: Number(values.gsuNew), month: dataPeriodo.month, year: dataPeriodo.year, name: dataPeriodo.name }))
            dispatch(storeLoadingSavingGsuBaseline(false))
            setOpenModal(false)
            form.resetFields()
        }
    }

    const validateDate = () => {

        let datePeriod  = new Date(Number(dataPeriodo.year), Number(dataPeriodo.month) - 1)
        let currentDate = new Date()
        currentDate.setHours(0)
        currentDate.setMinutes(0)
        currentDate.setSeconds(0)
        currentDate.setMilliseconds(0)
        currentDate.setDate(1)

        return !(datePeriod < currentDate)
    }

    function formattedNumber(value){

		return new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(value);
	}

    useEffect(() => {

    }, [rex_loading_saving_gsu])

    return (
        <Modal
            title={<div className='ModalNewProduct__Title'>Actualizar GSU/TON</div>} 
            open={openModal}
            onCancel={() => {
                setDataPeriodo({})
                setOpenModal(false)
            }}
            footer={null}
            width={550}
        >
            {
                rex_info_status_dashboard.code == "OnExecution"
                ? <div><LoadingOutlined /> En estos momentos el <b>Deck</b> y <b>AoC</b> se encuentran actualizandose con los últimos cambios realizados.</div>
                :   !validateDate()
                    ? 'Este valor no se puede modificar porque está fuera del periodo permitido'
                    : <Form
                        form={form}
                        name="modalUpdateGsu"
                        onFinish={onFinishForm}
                        layout='vertical'
                    >
                        <Row gutter={[12,12]}>
                            <Col span={12} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                                Actual: {formattedNumber(dataPeriodo.valuePrev)}
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label='Nuevo:'
                                    name='gsuNew'
                                >
                                    <InputNumber
                                        defaultValue={0}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24} style={{display:'flex', justifyContent:'end', gap:'10px'}}>
                                <Button danger>Cancelar</Button>
                                <Button 
                                    loading={rex_loading_saving_gsu}
                                    type='primary'
                                    htmlType="submit"
                                >{rex_loading_saving_gsu ? 'Guardando': 'Guardar'}</Button>
                            </Col>
                        </Row>
                    </Form>
            }
            
        </Modal>
    )
}

export default ModalUpdateGsuTon